import React, { PureComponent } from 'react';
import moment from 'moment';
import { Segment, isManualVehicleVrm } from '@fxtr/i18n';
import { Icon, Tooltip } from 'antd';
import { VRM, LogoImg, RightPanel, MOTPanel, LeftPanel, SmallTitle } from './styled';
import { HeaderBlockContainer } from '../styled';
import BookingHistory from '../BookingHistory';
import P from '../../../../components/P';
import Copyable from '$app/shared/components/Copyable';

const getYearRegistered = date => moment(date).format('YYYY');
const getmotExpiryDate = motExpiryDate => moment(motExpiryDate).format('DD MMM. YYYY');
const isComingSoon = motExpiryDate =>
  moment(motExpiryDate).isBefore(moment().add(4,'weeks')) ?
    {style:'mot_expires_soon', text: 'Expires soon - '} :
    {style:'mot_due', text: ''};
const getStyle = motExpiryDate => moment(motExpiryDate).isBefore(moment()) ?
  {style:'mot_expired', text: 'Expired - '} : isComingSoon(motExpiryDate);
const getMotData = motExpiryDate => {
  const {style, text} = getStyle(motExpiryDate);
  return (
    <MOTPanel className={style}>
      {style === 'mot_expired' ? <LogoImg src="/assets/icons/warning-icon.svg" className="logo" /> : null}
      <span className={style}>
        <P className={style} >{text} MOT valid until {getmotExpiryDate(motExpiryDate)}</P>
      </span>
    </MOTPanel>);
};

class VehicleDetails extends PureComponent {
  render() {
    const { bookingId, segment, vehicle, vehicleWeight, vehicleIdentificationMethod } = this.props;
    const showVrm = Boolean(vehicle.vrm && !isManualVehicleVrm(vehicle.vrm));
    const isManualDetails =
      vehicleIdentificationMethod === 'MANUAL_DETAILS' ||
      (vehicleIdentificationMethod == null && isManualVehicleVrm(vehicle.vrm));

    return (
      <HeaderBlockContainer>
        <LeftPanel>
          {showVrm ? (
            <VRM>
              {vehicle.vrm}
              <Copyable value={vehicle.vrm} />
            </VRM>
          ) : null}
          <BookingHistory bookingId={bookingId} vehicleWeight={vehicleWeight} />
        </LeftPanel>
        <RightPanel>
          <LogoImg src={vehicle.logo} alt={vehicle.make} className="logo" />
          <div className="textblock">
            <SmallTitle>
              {vehicle.make} {vehicle.model}
            </SmallTitle>
            <P>
              {isManualDetails
                ? vehicle.fuelType
                : [vehicle.litre, vehicle.fuelType].filter((part) => part != null && part !== '').join(' ')}
            </P>
            {vehicle.dateRegistered ? <P>{getYearRegistered(vehicle.dateRegistered)}</P> : null}
            <div className="last-read-mileage">
              {vehicle.lastReadMiles ? (
                <>
                  <span className="odometer">{`${vehicle.lastReadMiles}`}</span>{' '}
                  {`${segment === Segment.Fixter_FR ? 'km' : 'm'}`}{' '}
                  <Tooltip
                    title={`Submitted on ${new Date(vehicle.lastReadMileageDate).toLocaleDateString(
                      segment === Segment.Fixter_FR ? 'fr-FR' : 'en-GB'
                    )}`}
                  >
                    <Icon type="info-circle" />
                  </Tooltip>
                </>
              ) : (
                <>
                  No mileage submitted{' '}
                  {vehicle.lastEstimatedMiles ? (
                    <Tooltip
                      title={`Estimated ${vehicle.lastEstimatedMiles} ${
                        segment === Segment.Fixter_FR ? 'km' : 'm'
                      } on ${new Date(vehicle.lastReadMileageDate).toLocaleDateString(
                        segment === Segment.Fixter_FR ? 'fr-FR' : 'en-GB'
                      )}`}
                    >
                      <Icon type="info-circle" />
                    </Tooltip>
                  ) : null}
                </>
              )}
            </div>
          </div>
        </RightPanel>
        {vehicle.motExpiryDate ? getMotData(vehicle.motExpiryDate) : null}
      </HeaderBlockContainer>
    );
  }
}

export default VehicleDetails;
